import React from 'react';
import { Button, Col, Row, Popconfirm, Spin } from 'antd';
import BigQueryModal from '../BigQueryModal';
import InlineMessage from '../../atoms/InlineMessage';

const TheError = errorMessage => [
  <strong>Error</strong>,
  <br />,
  typeof errorMessage === 'string' ? errorMessage : 'Could not load audiences.',
];

const AudienceTab = ({
  show,
  count,
  isPolling,
  deleteAll,
  handleSubmit,
  deviceCount,
  submitting,
  errorMessage,
  hide,
  visible,
  fetching,
  showCreate,
  failed,
  handleRunTest,
  toggleCreate,
}) => (
  <div>
    <BigQueryModal
      title="Audiences Query"
      onHideBigQuery={handleSubmit}
      loadingAudienceQuery={submitting}
      visible={visible}
      deviceCount={deviceCount}
      handleRunTest={handleRunTest}
      hideModal={hide}
    />
    {failed && <InlineMessage type="error" message={TheError(errorMessage)} />}
    {!failed && (
      <Spin spinning={!isPolling && fetching}>
        <Row>
          <p>Audience targeting only applies to inStore Moments</p>
          {!showCreate && (
            <Button
              size="large"
              onClick={() => {
                toggleCreate();
                show();
              }}
            >
              Create Device Targeting Query
            </Button>
          )}
          {showCreate
            ? [
                <Col key={1} span={12}>
                  <Button disabled={isPolling} onClick={show}>
                    {!deviceCount && !count ? 'Create Query' : 'View/Edit Query'}
                  </Button>
                </Col>,
                <Col key={2} span={12}>
                  <Spin spinning={isPolling}>
                    <p>
                      {deviceCount && count !== deviceCount
                        ? `${count.toLocaleString()} / ${deviceCount.toLocaleString()} Devices targeted`
                        : `${count.toLocaleString()} Devices targeted`}
                      <br />
                      <Popconfirm
                        placement="topRight"
                        title="Are you sure you want to remove all devices?"
                        onConfirm={deleteAll}
                        okText="Yes"
                        cancelText="No"
                      >
                        {deviceCount || count ? <a href="#remove">Remove all Devices</a> : null}
                      </Popconfirm>
                    </p>
                  </Spin>
                </Col>,
              ]
            : null}
        </Row>
      </Spin>
    )}
  </div>
);

export default AudienceTab;
